<script setup lang="ts">
import Banner from '~/shared/ui/banner/Banner.vue';
import {
  BANNER_ARTICLE_BOUNDARY_FULL_A_DESKTOP_PARAMS,
  BANNER_ARTICLE_BOUNDARY_FULL_A_TABLET_PARAMS,
  BANNER_ARTICLE_BOUNDARY_FULL_A_MOBILE_PARAMS,
} from '~/shared/lib/banners';

defineProps<{
  index: number;
}>();

const PLACEHOLDER_HEIGHTS = {
  xs: '480/240',
  mobile: '480/240',
  mobileBig: '768/120',
  tablet: '1536/240',
  tabletBig: '1536/240',
  desktop: '1080/120',
};
</script>

<template>
  <div :class="$style.banner">
    <Banner
      :config="[
        BANNER_ARTICLE_BOUNDARY_FULL_A_DESKTOP_PARAMS,
        BANNER_ARTICLE_BOUNDARY_FULL_A_TABLET_PARAMS,
        BANNER_ARTICLE_BOUNDARY_FULL_A_MOBILE_PARAMS,
      ]"
      :index="index"
      align="center"
      width="100%"
      show-placeholder
      :placeholder-heights="PLACEHOLDER_HEIGHTS"
    />
  </div>
</template>

<style module lang="scss">
.banner {
  display: flex;
  flex-flow: row nowrap;
  flex: 1 0 auto;
}

@media (max-width: 599px) {
  .banner {
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    text-align: center;
    width: 100%;
  }
}

@media (max-width: 479px) {
  .banner {
    padding: var(--space-2x);
  }
}
</style>
